import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';

const SalesBook = () => {
  return (
    <div className="space-y-4">
      <Card className="glass shadow-lg border-0">
        <CardHeader>
          <CardTitle>Sales Book</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="text-sm text-gray-600 dark:text-gray-200">
            Numora Sales Book module is ready for implementation.
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default SalesBook;

